import CloseIcon from "@mui/icons-material/Close";
import { Drawer } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./m3.module.css";

/**
 * M3 modal side sheet (right-hand drawer) with a header, a scrolling body and a pinned footer.
 * Goes full-screen below 640px.
 *
 * @param {React.ReactNode} headerExtra - rendered under the title (e.g. a mode switch)
 * @param {React.ReactNode} footerStart - footer content aligned left
 * @param {React.ReactNode} footer - footer content aligned right (primary actions)
 * @param {number|string} width - sheet width on desktop (default 560)
 */
const SideSheet = ({ open, onClose, title, subtitle, headerExtra, children, footer, footerStart, width = 560 }) => {
  const { t } = useTranslation();
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{ zIndex: 1500 }}
      style={{ zIndex: 1500 }}
      slotProps={{ paper: { className: styles.sheetPaper, style: { width } } }}
      PaperProps={{ className: styles.sheetPaper, style: { width } }}
    >
      <div className={styles.sheetHeader}>
        <div className={styles.sheetHeadText}>
          <h2 className={styles.sheetTitle}>{title}</h2>
          {subtitle && <p className={styles.sheetSubtitle}>{subtitle}</p>}
        </div>
        <button type="button" className={`${styles.iconBtn} ${styles.iconBtnStandard}`} onClick={onClose} aria-label={t("Close")}>
          <CloseIcon />
        </button>
      </div>
      {headerExtra && <div className={styles.sheetExtra}>{headerExtra}</div>}
      <div className={styles.sheetBody}>{children}</div>
      {(footer || footerStart) && (
        <div className={styles.sheetFooter}>
          {footerStart}
          <span className={styles.sheetFooterSpacer} />
          {footer}
        </div>
      )}
    </Drawer>
  );
};

export default SideSheet;
